export default function CitasPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">📝 Citas del Calendario</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">
          Módulo de gestión de citas del calendario hebreo en desarrollo.
        </p>
      </div>
    </div>
  );
}






